export enum DataRoomType {
  /**
   * @deprecated Not used anymore, MediaInsights is the latest
   */
  Media = "Media",
  DataScience = "DataScience",
  /**
   * @deprecated Not used anymore, MediaInsights is the latest
   */
  LookalikeMedia = "LookalikeMedia",
  MediaInsights = "MediaInsights",
  Measurement = "Measurement",
}
